import React, { useState, useEffect } from 'react'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import { Radio, RadioGroup } from 'rsuite';
import Select from 'react-select'
import ThreeStateToggleButton from '../../CommonComponents/ThreeStateToggleButton';

const AdvanceAcceptanceDetailsContent = ({ deliveryMethodName, deliveryMethodData, updateFeeData, disabled = false }) => {
    const [showMinFee, setShowMinFee] = useState(false)
    const [showMaxFee, setShowMaxFee] = useState(false)
    const [showIncrementalFee, setShowIncrementalFee] = useState(false)
    const [showAnotherProcessingFee, setShowAnotherProcessingFee] = useState(false)

    useEffect(() => {
        setShowMinFee(deliveryMethodData?.minPaymentFeeValue ? true : false)
        setShowMaxFee(deliveryMethodData?.maxPaymentFeeValue ? true : false)
        setShowIncrementalFee(deliveryMethodData?.incrementalFeeValue ? true : false)
        setShowAnotherProcessingFee(deliveryMethodData?.secondProcessingFeeValue ? true : false)
    }, [disabled])

    return (
        <>
            <div className='row'>
                <h6 className='text-black fw-bold'> Card Acceptance </h6>
                <div className='flex row-data card-acceptance-methods mt-4'>
                    <CheckboxComponent
                        label='Amex'
                        onChange={(checked) => { updateFeeData('isAcceptAmericanExpress', checked, deliveryMethodName) }}
                        checked={deliveryMethodData['isAcceptAmericanExpress']}
                        disabled={disabled}
                    />
                    <CheckboxComponent
                        label='Visa'
                        onChange={(checked) => { updateFeeData('isAcceptVisa', checked, deliveryMethodName) }}
                        checked={deliveryMethodData['isAcceptVisa']}
                        disabled={disabled}
                    />
                    <CheckboxComponent
                        label='MasterCard'
                        onChange={(checked) => { updateFeeData('isAcceptMasterCard', checked, deliveryMethodName) }}
                        checked={deliveryMethodData['isAcceptMasterCard']}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className='row'>
                <h6 className='text-black fw-bold'> Token Configuration </h6>
                <div className='flex row-data mt-4'>
                    <RadioGroup name="radioList" className='flex' inline={true} value={deliveryMethodData['tokenType']}>
                        <Radio value="single-use-max-amount" onChange={() => { updateFeeData('tokenType', 'single-use-max-amount', deliveryMethodName) }} disabled={disabled}>Single-Use Max Amount</Radio>
                        <Radio value="multi-use" onChange={() => { updateFeeData('tokenType', 'multi-use', deliveryMethodName) }} disabled={disabled}>Multi-Use</Radio>
                        <Radio value="reloadable" onChange={() => { updateFeeData('tokenType', 'reloadable', deliveryMethodName) }} disabled={disabled}>Reloadable</Radio>
                    </RadioGroup>
                </div>
            </div>
            <div className='flex flex-column accept-item'>
                <div className='flex fee-payment-header'>
                    <h6 className='text-black fw-bold'> Fee </h6>
                    <h6 className='text-black fw-bold'> Payment Amount </h6>
                </div>

                <div className="flex flex-column row-data g-0 mt-4">
                    <h4 className="name mb-0">Processing Fee</h4>
                    <div className='processing-fee-parent flex'>
                        <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                            <div className='d-flex'>
                                <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                    <Select
                                        className="processing-fee-dropdown"
                                        options={
                                            [
                                                {
                                                    label: '$',
                                                    value: '$',
                                                },
                                                {
                                                    label: '%',
                                                    value: '%',
                                                },
                                            ]
                                        }
                                        value={{
                                            label: deliveryMethodData['processingFeeType'],
                                            value: deliveryMethodData['processingFeeType'],
                                        }}
                                        onChange={(item) => { updateFeeData('processingFeeType', item?.value, deliveryMethodName, '', 'processingFeeValue') }}
                                        isDisabled={disabled}
                                    />
                                    <input
                                        className='search-input h4 mb-0'
                                        onChange={(e) => { updateFeeData('processingFeeValue', e.target.value, deliveryMethodName, 'number', '', deliveryMethodData['processingFeeType']) }}
                                        value={deliveryMethodData['processingFeeValue']}
                                        readOnly={disabled}
                                        placeholder={deliveryMethodData['processingFeeType'] === '$' ? '1,234.00' : '12.50'}
                                    />
                                </div>
                                <button className='ms-2 show-option-btn' disabled={(!deliveryMethodData?.processingFeeValue || showAnotherProcessingFee) ? true : false} onClick={() => setShowAnotherProcessingFee(true)}> + </button>
                            </div>

                            {showAnotherProcessingFee && (
                                <div className='d-flex'>
                                    <div className='flex processing-fee-dropdown-parent align-center gap-0'>
                                        <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                            <Select // flex-sm-grow-0
                                                menuMaxHeight={48}
                                                className="processing-fee-dropdown h4 mb-0"
                                                options={
                                                    [
                                                        {
                                                            label: '$',
                                                            value: '$',
                                                        },
                                                        {
                                                            label: '%',
                                                            value: '%',
                                                        },
                                                    ]
                                                }
                                                value={{
                                                    label: deliveryMethodData['secondProcessingFeeType'],
                                                    value: deliveryMethodData['secondProcessingFeeType'],
                                                }}
                                                onChange={(item) => { updateFeeData('secondProcessingFeeType', item?.value, deliveryMethodName, '', 'secondProcessingFeeValue') }}
                                                isDisabled={disabled}
                                            />
                                            <input
                                                className='search-input h4 mb-0'
                                                onChange={(e) => { updateFeeData('secondProcessingFeeValue', e.target.value, deliveryMethodName, 'number', '', deliveryMethodData['secondProcessingFeeType']) }}
                                                value={deliveryMethodData['secondProcessingFeeValue']}
                                                readOnly={disabled}
                                                placeholder={deliveryMethodData['secondProcessingFeeType'] === '$' ? '1,234.00' : '12.50'}
                                            />
                                        </div>
                                        <button className='ms-2 hide-option-btn' onClick={() => setShowAnotherProcessingFee(false)}> - </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='d-none d-sm-block'></div>
                    </div>
                </div>
                <div className='flex flex-column row-data mt-4'>
                    <span className='text-black'> Minimum Payment </span>
                    <div className='processing-fee-parent flex'>
                        {showMinFee ? (
                            <div className='flex processing-fee-dropdown-parent align-center'>
                                <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                        className="processing-fee-dropdown"
                                        options={
                                            [
                                                {
                                                    label: '$',
                                                    value: '$',
                                                },
                                                {
                                                    label: '%',
                                                    value: '%',
                                                },
                                            ]
                                        }
                                        value={{
                                            label: deliveryMethodData['minPaymentFeeType'],
                                            value: deliveryMethodData['minPaymentFeeType'],
                                        }}
                                        onChange={(item) => { updateFeeData('minPaymentFeeType', item?.value, deliveryMethodName, '', 'minPaymentFeeValue') }}
                                        isDisabled={disabled}
                                    />
                                    <input
                                        className='search-input h4 mb-0'
                                        onChange={(e) => { updateFeeData('minPaymentFeeValue', e.target.value, deliveryMethodName, 'number', '', deliveryMethodData['minPaymentFeeType']) }}
                                        value={deliveryMethodData['minPaymentFeeValue']}
                                        readOnly={disabled}
                                        placeholder={deliveryMethodData['minPaymentFeeType'] === '$' ? '1,234.00' : '12.50'}
                                    />
                                </div>
                                <span className='text-black'>Fee if under</span>
                            </div>
                        )
                            : <div></div>}
                        <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                                {deliveryMethodData['minPaymentAmount'] ?
                                    <span>$</span>
                                    :
                                    ''
                                }
                                <input
                                    type="text"
                                    className={`search-input h4 mb-0 ${deliveryMethodData['minPaymentAmount'] ? 'has-value' : ''}`}
                                    onChange={(e) => { updateFeeData('minPaymentAmount', e.target.value, deliveryMethodName, 'number', '', '$') }}
                                    value={deliveryMethodData['minPaymentAmount']}
                                    placeholder='$ 1,234.00'
                                    readOnly={disabled}
                                />
                            </div>
                            {showMinFee ?
                                <button className='hide-option' onClick={() => setShowMinFee(false)} disabled={disabled}> - </button>
                                :
                                <button className='show-option' onClick={() => setShowMinFee(true)} disabled={disabled}> + </button>
                            }
                        </div>
                    </div>
                </div>
                <div className='flex flex-column row-data mt-4'>
                    <span className='text-black'> Maximum Payment </span>
                    <div className='processing-fee-parent flex'>
                        {showMaxFee ? (
                            <div className='flex processing-fee-dropdown-parent align-center'>
                                <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                        className="processing-fee-dropdown"
                                        options={
                                            [
                                                {
                                                    label: '$',
                                                    value: '$',
                                                },
                                                {
                                                    label: '%',
                                                    value: '%',
                                                },
                                            ]
                                        }
                                        value={{
                                            label: deliveryMethodData['maxPaymentFeeType'],
                                            value: deliveryMethodData['maxPaymentFeeType']
                                        }}
                                        onChange={(item) => { updateFeeData('maxPaymentFeeType', item?.value, deliveryMethodName, '', 'maxPaymentFeeValue') }}
                                        isDisabled={disabled}
                                    />
                                    <input
                                        className='search-input h4 mb-0'
                                        onChange={(e) => { updateFeeData('maxPaymentFeeValue', e.target.value, deliveryMethodName, 'number', '', deliveryMethodData['maxPaymentFeeType']) }}
                                        value={deliveryMethodData['maxPaymentFeeValue']}
                                        readOnly={disabled}
                                        placeholder={deliveryMethodData['maxPaymentFeeType'] === '$' ? '1,234.00' : '12.50'}
                                    />
                                </div>
                                <span className='text-black'>Fee if over</span>
                            </div>
                        )
                            : <div></div>}
                        <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                                {deliveryMethodData['maxPaymentAmount'] ?
                                    <span>$</span>
                                    :
                                    ''
                                }
                                <input
                                    type="text"
                                    className={`search-input h4 mb-0 ${deliveryMethodData['maxPaymentAmount'] ? 'has-value' : ''}`}
                                    onChange={(e) => { updateFeeData('maxPaymentAmount', e.target.value, deliveryMethodName, 'number', '', '$') }}
                                    value={deliveryMethodData['maxPaymentAmount']}
                                    placeholder='$ 1,234.00'
                                    readOnly={disabled}
                                />
                            </div>
                            {showMaxFee ?
                                <button className='hide-option' onClick={() => setShowMaxFee(false)} disabled={disabled}> - </button>
                                :
                                <button className='show-option' onClick={() => setShowMaxFee(true)} disabled={disabled}> + </button>
                            }
                        </div>
                    </div>
                </div>
                <div className='flex flex-column row-data mt-4'>
                    <span className='text-black'> Incremental Payment </span>
                    <div className='processing-fee-parent flex'>
                        {showIncrementalFee ? (
                            <div className='flex processing-fee-dropdown-parent align-center'>
                                <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                        className="processing-fee-dropdown"
                                        options={
                                            [
                                                {
                                                    label: '$',
                                                    value: '$',
                                                },
                                                {
                                                    label: '%',
                                                    value: '%',
                                                },
                                            ]
                                        }
                                        value={{
                                            label: deliveryMethodData['incrementalFeeType'],
                                            value: deliveryMethodData['incrementalFeeType']
                                        }}
                                        onChange={(item) => { updateFeeData('incrementalFeeType', item?.value, deliveryMethodName, '', 'incrementalFeeValue') }}
                                        isDisabled={disabled}
                                    />
                                    <input
                                        className='search-input h4 mb-0'
                                        onChange={(e) => { updateFeeData('incrementalFeeValue', e.target.value, deliveryMethodName, 'number', '', deliveryMethodData['incrementalFeeType']) }}
                                        value={deliveryMethodData['incrementalFeeValue']}
                                        readOnly={disabled}
                                        placeholder={deliveryMethodData['incrementalFeeType'] === '$' ? '1,234.00' : '12.50'}
                                    />
                                </div>
                                <span className='text-black'>Fee for every</span>
                            </div>
                        )
                            : <div></div>}
                        <div className='flex payment-parent'>
                            {showIncrementalFee ? (
                                <div className="search-input-parent currency">
                                    {deliveryMethodData['incrementalPaymentAmount'] ?
                                        <span>$</span>
                                        :
                                        ''
                                    }
                                    <input
                                        type="text"
                                        className={`search-input h4 mb-0 ${deliveryMethodData['incrementalPaymentAmount'] ? 'has-value' : ''}`}
                                        onChange={(e) => { updateFeeData('incrementalPaymentAmount', e.target.value, deliveryMethodName, 'number', '', '$') }}
                                        value={deliveryMethodData['incrementalPaymentAmount']}
                                        placeholder='$ 1,234.00'
                                        readOnly={disabled}
                                    />
                                </div>
                            ) :
                                <div></div>}

                            {showIncrementalFee ?
                                <button className='hide-option' onClick={() => setShowIncrementalFee(false)} disabled={disabled}> - </button>
                                :
                                <button className='show-option' onClick={() => setShowIncrementalFee(true)} disabled={disabled}> + </button>
                            }
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-center mt-4'>
                    <h6 className='toggle-item-text text-black'> Variable Fee </h6>
                    <ThreeStateToggleButton
                        onChange={(checked) => { updateFeeData('isAcceptVariableFee', checked, deliveryMethodName) }}
                        checked={deliveryMethodData['isAcceptVariableFee']}
                        disabled={disabled}
                    />
                </div>
            </div>
        </>
    )
}

export default AdvanceAcceptanceDetailsContent;